// imported in base router.ts
export default
	[
		/*{
		path: "/contentstream/:id/",
		name: "contentstream",
		component: () => import("@/Views/ContentStream/ContentStream.vue"),
		props: true,
		children: [
		]
	},*/
		{
			path: "/contentstream/:id/",
			name: "contentstreamhome",
			component: () => import("@/Views/ContentStream/ContentStreamHome.vue"),
			props: true,
			meta: { name: "Content Stream", page: "stream" }
		},
		{
			path: "/contentstream/:id/level/:levelid",
			name: "contentstreamlevel",
			component: () => import("@/Views/ContentStream/ContentStreamLevel.vue"),
			props: true,
			meta: { name: "Content Stream Level", page: "stream" }
		},
		{
			path: "/contentstream/:id/levels",
			name: "contentstreamlevels",
			component: () => import("@/Views/ContentStream/ContentStreamLevels.vue"),
			props: true,
			meta: { name: "Content Stream Pricing", page: "stream" }
		},

		{
			path: "/contentstream/:id/billingsetup",
			name: "contentstreambillingconfiguration",
			component: () => import("@/Views/ContentStream/ContentStreamBillingConfiguration.vue"),
			props: true,
			meta: { name: "Content Stream Issue", page: "stream" }
		},
		{
			path: "/contentstream/:id/issue/:issueid",
			name: "contentstreamissue",
			component: () => import("@/Views/ContentStream/ContentStreamIssue.vue"),
			props: true,
			meta: { name: "Content Stream Issue", page: "stream" }
		},
		{
			path: "/contentstream/:id/todo",
			name: "contentstreamtodo",
			component: () => import("@/Views/ContentStream/ContentStreamTodo.vue"),
			props: true,
			meta: { name: "Content Stream Todo", page: "account" }
		}
	];
